export enum GetDataResponseCode {
	Success = 1,
	InternalError = 2,
	ShiftEnded = 4
}
